import PropTypes from "prop-types";

export const FormIntro = ({ title, subtitle, info }) => {
  return (
    <div className="w-full max-w-xs mx-auto text-center">
      <div className="text-2xl font-bold" dangerouslySetInnerHTML={{ __html: title }}></div>
      <div className="mt-8 text-lg" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
      {info && (
        <div className="my-8 text-xxs" dangerouslySetInnerHTML={{ __html: info }}></div>
      )}
    </div>
  );
};

FormIntro.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  info: PropTypes.string,
};




